import React from 'react';
import Container from '../ui/Container';
import { Users, BookOpen, Clock, Star } from 'lucide-react';

const stats = [
  {
    icon: Users,
    value: '10,000+',
    label: 'Active Students',
    color: 'text-blue-600'
  },
  {
    icon: BookOpen,
    value: '1,000+',
    label: 'Expert Teachers',
    color: 'text-green-600'
  },
  {
    icon: Clock,
    value: '100,000+',
    label: 'Hours Taught',
    color: 'text-purple-600'
  },
  {
    icon: Star,
    value: '4.9/5',
    label: 'Average Rating',
    color: 'text-yellow-600'
  }
];

const StatsSection = () => {
  return (
    <section className="py-16 bg-white">
      <Container>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className={`inline-flex p-4 rounded-full bg-gray-50 mb-4 ${stat.color}`}>
                <stat.icon className="w-8 h-8" />
              </div>
              <div className="text-3xl font-bold mb-2">{stat.value}</div>
              <div className="text-gray-600">{stat.label}</div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default StatsSection;